import { z } from 'zod';

// ── path schemas ──────────────────────────────────────────────────────────────

export const TextractDocumentPathSchema = z.object({
  documentID: z.string(),
});

// ── entity schemas ────────────────────────────────────────────────────────────

export const FieldMappingSchema = z
  .object({
    name: z.string(),
    display_name: z.string(),
    type: z.string(),
  })
  .transform((raw) => ({
    name: raw.name,
    displayName: raw.display_name,
    type: raw.type,
  }));

export type FieldMapping = z.output<typeof FieldMappingSchema>;

// ── response schemas ──────────────────────────────────────────────────────────

export const FieldsMappingResponseSchema = z.array(FieldMappingSchema);
